import { render, staticRenderFns } from "./stopdetails.vue?vue&type=template&id=16c00384&scoped=true&"
import script from "./stopdetails.vue?vue&type=script&lang=js&"
export * from "./stopdetails.vue?vue&type=script&lang=js&"
import style0 from "./stopdetails.vue?vue&type=style&index=0&id=16c00384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c00384",
  null
  
)

export default component.exports